import type { TApiFinancialFile } from "@/apis/proda_finance";
import type { TFileStatus, TFileType, TFinancialFile } from "@/store";

const API_FILE_TYPE_MAP: Record<string, TFileType> = {
    trial_balance: "tb",
    general_ledger: "gl",
    open_trial_balance: "otb",
    financial_journals: "fin_journals",
    tb_gl: "tb_gl",
};

export function mapApiFileType(apiFileType: string): TFileType {
    return API_FILE_TYPE_MAP[apiFileType] ?? (apiFileType as TFileType);
}

const STORE_TO_API_FILE_TYPE: Record<TFileType, string> = {
    tb: "trial_balance",
    gl: "general_ledger",
    otb: "open_trial_balance",
    fin_journals: "financial_journals",
    tb_gl: "tb_gl",
};

export function mapStoreFileTypeToApi(storeFileType: string): string {
    return STORE_TO_API_FILE_TYPE[storeFileType as TFileType] ?? storeFileType;
}

export function mapApiFileToStore(f: TApiFinancialFile): TFinancialFile {
    return {
        id: f.id,
        dealId: f.deal_id,
        dealName: f.deal_name ?? "",
        serviceProviderName: f.service_provider_name ?? "",
        bookId: f.book_id ?? null,
        bookName: null,
        period: f.period,
        fileType: mapApiFileType(f.file_type),
        status: f.status as TFileStatus,
        originalFilename: f.original_filename,
        uploadedById: f.uploaded_by_id ?? "",
        uploadedByName: "",
        uploadedAt: f.uploaded_at ?? f.created_at,
        processedAt: f.processing_completed_at,
        lineItemCount: f.total_line_items ?? 0,
        totalAmount: parseFloat(f.balance ?? "0"),
        validationErrors: f.validation_errors ? JSON.parse(f.validation_errors) : [],
        rejectionReason: f.rejection_reason ?? null,
        yardiUploadStatus: f.yardi_upload_status ?? null,
        yardiBatchId: f.yardi_batch_id ?? null,
        archivedAt: f.archived_at ?? null,
        archiveReason: f.archive_reason ?? null,
        dealIsActive: f.deal_is_active ?? null,
    };
}
